export enum HorizontalPositions {
  start = 'start',
  center = 'center',
  end = 'end',
}
